import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { reportMixpanelEvent, withConfiguredImpressions } from '../../../shared/hoc/withImpressionReviews';
import { ReviewItemPropType } from '../../PropTypes';
import useObserver from '../../../shared/hooks/useObserver';
import { isBusinessDomain } from '../../../../utils/business';
import { shouldDisplayTranslation } from '../../../../utils/translation';
import useTranslation from '../../../shared/hooks/useTranslation';
import { useReviewsContext } from '../../../shared/context';
import ReliableReviewItem from './ReliableReviewItem';
import './styles.scss';

const componentName = 'gig_reviews_detailed';
const COMPONENT_CLASS = 'review-item-component';

export const ReviewItem = ({ review, position = 1 }) => {
    const reviewsRef = useRef(null);
    const context = getContext();
    const { initialState } = useReviewsContext();
    const { locale } = context;
    const {
        work_sample_url: workSampleUrl,
        work_sample_preview_url: workSamplePreviewUrl,
        work_sample_content_type: workSampleContentType,
        comment: originalText,
        highlighted_comment: highlightedText,
        comment_language: sourceLanguage,
        reviewer_industry: reviewerIndustry,
        username,
        is_business: isBusinessReview,
    } = review;

    useObserver({
        observableRef: reviewsRef,
        onObserve: () => reportMixpanelEvent({ position, username, isBusinessReview }),
    });

    const displayTranslationButton = shouldDisplayTranslation(locale, sourceLanguage);
    const { translationConfig, text } = useTranslation(originalText, sourceLanguage);
    const shouldHighlight = !translationConfig.isTranslatedText && !!highlightedText;

    const descriptionText = shouldHighlight ? highlightedText : text;

    const workSampleData = workSamplePreviewUrl
        ? {
              url: workSampleUrl,
              previewUrl: workSamplePreviewUrl,
              contentType: workSampleContentType,
              position,
              eventData: {
                  origin: initialState.biEventGroup,
                  reason: workSampleContentType,
              },
          }
        : null;

    const showBusinessBadge = isBusinessReview && isBusinessDomain();

    return (
        <li ref={reviewsRef} className={COMPONENT_CLASS}>
            <ReliableReviewItem
                review={review}
                position={position}
                descriptionText={descriptionText}
                shouldHighlight={shouldHighlight}
                showBusinessBadge={showBusinessBadge}
                displayTranslationButton={displayTranslationButton}
                reviewerIndustry={reviewerIndustry}
                translationConfig={translationConfig}
                componentName={componentName}
                workSampleData={workSampleData}
            />
        </li>
    );
};

ReviewItem.propTypes = {
    review: ReviewItemPropType,
    position: PropTypes.number,
};

export default withConfiguredImpressions(ReviewItem, COMPONENT_CLASS);
